'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeVisualTheme = {
    fromJson: fromJson,
    getVisualTheme: getVisualTheme,
};

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'VisualTheme', reqProps, reqProps,
        function(data) { return getVisualTheme(data.$id); }
    );
}

function getVisualTheme(themeId) {
    var key = 'VisualTheme: ' + themeId;
    var visualTheme = KayleeCache.get(key);

    if (visualTheme === null) {
        visualTheme = new VisualTheme(themeId);
        KayleeCache.put(key, visualTheme);
    }

    return visualTheme;
}

function VisualTheme(themeId) {
    this.$nodeType = 'visualTheme';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('visualThemes/' + themeId));
}

VisualTheme.prototype = Object.create(FirebaseObject.prototype);
VisualTheme.prototype.constructor = VisualTheme;

VisualTheme.prototype.$defaults = {
    colorPrimary: '#11355F',
    colorSecondary: '#568BEA',
    colorHighlight: '#568BEA',
    colorLightHighlight: 'rgba(86, 139, 234, 0.3)',
    colorTextPrimary: '#FFFFFF',
    colorTextSecondary: '#FFFFFF',
    colorTextHighlight: '#FFFFFF',
    colorTextLightHighlight: '#FFFFFF',
    colorTextBackground: '#FFFFFF',
    colorBackground: '#000000',
};

VisualTheme.prototype.$storage = {
    visualTheme: {
        backgroundImage: true,
        logo: true,
    },
};

VisualTheme.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ], {});
};

VisualTheme.prototype.toString = function() {
    if (this.$internalIsLoaded) {
        return '[VisualTheme "' + this.name + '" (' + this.$id + ')]';
    }

    return '[VisualTheme (' + this.$id + ')]';
};

module.exports = KayleeVisualTheme;